<template>
	<view class="mine-page">
		<view class="top-bg"></view>
		<view class="nav-wrap">
			<view :style="{ height: statusbarHeight + 'px' }"></view>
			<view class="nav-bar" :style="{ height: navHeight + 'px' }">
				<view class="nav-spacer"></view>
				<view class="nav-actions">
					<view class="nav-action-item">
						<u-icon name="more-dot-fill" size="30" color="#222222"></u-icon>
					</view>
					<view class="nav-divider"></view>
					<view class="nav-action-item">
						<u-icon name="scan" size="24" color="#222222"></u-icon>
					</view>
				</view>
			</view>
		</view>

		<view class="page-scroll">
			<view class="page-content">
				<view class="profile-card">
					<image class="avatar" src="/static/image/tx@2x.png" mode="widthFix"></image>
					<view class="profile-copy">
						<text class="login-text">{{ isLoggedIn ? maskedMobile : '点击登录' }}</text>
						<text v-if="isLoggedIn" class="user-name">{{ userName }}</text>
					</view>
					<view v-if="isLoggedIn" class="profile-tools">
						<view class="tool-item">
							<image class="tool-icon" src="/static/icon/ic_option@2x.png" mode="aspectFit"></image>
						</view>
						<view class="tool-item has-badge">
							<image class="tool-icon" src="/static/icon/ic_notice@2x.png" mode="aspectFit"></image>
							<view class="tool-badge"></view>
						</view>
					</view>
				</view>

				<view class="order-card section-card">
					<view class="section-head">
						<text class="section-title">我的订单</text>
						<view class="more-wrap">
							<text class="more-text">全部订单</text>
							<u-icon name="arrow-right" size="13" color="#999999"></u-icon>
						</view>
					</view>
					<view class="order-grid">
						<view v-for="item in orderMenus" :key="item.label" class="order-item">
							<image class="order-icon" :src="item.url" mode="widthFix"></image>
							<view v-if="item.badge && isLoggedIn" class="order-badge">{{ item.badge }}</view>
							<text class="order-label">{{ item.label }}</text>
						</view>
					</view>
				</view>

				<view class="banner-card">
					<image class="banner-image" src="/static/image/share@2x.png" mode="widthFix"></image>
				</view>

				<view class="menu-card section-card">
					<view v-for="item in menuList" :key="item.label" class="menu-row">
						<text class="menu-label">{{ item.label }}</text>
						<u-icon name="arrow-right" size="18" color="#B5BBC5"></u-icon>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight']),
			maskedMobile() {
				if (!this.isLoggedIn || !this.mobile) {
					return '点击登录'
				}
				return `${this.mobile.slice(0, 3)}****${this.mobile.slice(-4)}`
			}
		},
		data() {
			return {
				isLoggedIn: true,
				mobile: '18166669990',
				userName: '蔡子瑄',
				orderMenus: [
					{ label: '待支付', url: '/static/icon/mine_ic_daifukuan@2x.png', badge: 12 },
					{ label: '待收货', url: '/static/icon/mine_ic_daishouhuo@2x.png', badge: 2 },
					{ label: '退款/售后', url: '/static/icon/mine_ic_tuikuan@2x.png' }
				],
				menuList: [
					{ label: '门店入驻' },
					{ label: '我的门店' },
					{ label: '规范须知' },
					{ label: '在线客服' },
					{ label: '关于我们' }
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.mine-page {
		position: relative;
		min-height: 100vh;
		background: #f6f8fb;
	}

	.top-bg {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 450rpx;
		background: linear-gradient(180deg, #B9E9FF 0%, #ffffff 100%);
		z-index: 0;
	}

	.nav-wrap,
	.page-scroll {
		position: relative;
		z-index: 1;
	}

	.nav-bar {
		padding: 0 16rpx;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
	}

	.nav-spacer {
		width: 52rpx;
		height: 52rpx;
	}

	.nav-actions {
		min-width: 112rpx;
		height: 52rpx;
		padding: 0 10rpx;
		background: rgba(255, 255, 255, 0.86);
		border-radius: 26rpx;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
	}

	.nav-action-item {
		width: 38rpx;
		height: 38rpx;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.nav-divider {
		width: 1rpx;
		height: 24rpx;
		background: #e5e7eb;
	}

	.page-content {
		padding: 30rpx;
		box-sizing: border-box;
	}

	.profile-card {
		display: flex;
		align-items: center;
		margin-bottom: 30rpx;
	}

	.avatar {
		width: 108rpx;
		height: 108rpx;
		border-radius: 50%;
		overflow: hidden;
		margin-right: 24rpx;
	}

	.login-text {
		font-weight: 600;
		font-size: 36rpx;
		color: #111111;
	}

	.profile-copy {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.user-name {
		margin-top: 12rpx;
		font-weight: 400;
		font-size: 26rpx;
		color: #7d8792;
	}

	.profile-tools {
		display: flex;
		align-items: center;
		gap: 20rpx;
	}

	.tool-item {
		position: relative;
		width: 40rpx;
		height: 40rpx;
	}

	.tool-icon {
		width: 100%;
		height: 100%;
	}

	.tool-badge {
		position: absolute;
		right: -4rpx;
		top: -4rpx;
		width: 12rpx;
		height: 12rpx;
		border-radius: 50%;
		background: #ff3b30;
	}

	.section-card {
		background: #ffffff;
		border-radius: 18rpx;
	}

	.order-card {
		padding: 30rpx;
		box-sizing: border-box;
	}

	.section-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 30rpx;
	}

	.section-title {
		font-size: 34rpx;
		font-weight: 600;
		color: #222222;
	}

	.more-wrap {
		display: flex;
		align-items: center;
		gap: 4rpx;
	}

	.more-text {
		font-size: 24rpx;
		color: #b5bbc5;
	}

	.order-grid {
		display: flex;
		align-items: center;
		justify-content: space-around;
		padding: 8rpx 14rpx 0;
	}

	.order-item {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.order-badge {
		position: absolute;
		top: -6rpx;
		right: -15rpx;
		min-width: 28rpx;
		height: 28rpx;
		padding: 0 6rpx;
		border-radius: 14rpx;
		background: #ff2d55;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18rpx;
		line-height: 1;
		color: #ffffff;
		box-sizing: border-box;
	}

	.order-icon {
		width: 60rpx;
		height: 60rpx;
	}

	.order-label {
		margin-top: 8rpx;
		font-weight: 400;
		font-size: 24rpx;
		color: #333333;
	}

	.banner-card {
		position: relative;
		margin-top: 30rpx;
		width: 100%;
		overflow: hidden;
	}

	.banner-image {
		width: 100%;
	}

	.menu-card {
		margin-top: 30rpx;
		padding: 0 30rpx;
		box-sizing: border-box;
	}

	.menu-row {
		height: 100rpx;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1rpx solid #E5E5E5;
	}

	.menu-row:last-child {
		border-bottom: none;
	}

	.menu-label {
		font-weight: 400;
		font-size: 30rpx;
		color: #222222;
	}
</style>
